import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Instagram, Twitter } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();
  
  // Dil bazlı privacy path
  const privacyPath = language === 'de' ? '/datenschutz' : '/privacy';
  
  return (
    <footer className="bg-[#1a1a1a] text-white/70 border-t border-white/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          {/* Company Info */}
          <div className="text-center sm:text-left">
            <div className="flex items-center justify-center sm:justify-start mb-1">
              <img 
                src="./images/slai-final-logo.png" 
                alt="SLÁI Events" 
                className="h-16 sm:h-20 object-contain invert mix-blend-screen"
              />
            </div>
            <div className="w-16 h-[1px] bg-white/40 mb-1 mx-auto sm:mx-0" />
            <p className="text-sm text-white/60 mt-4" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
              {t.company.tagline}
            </p>
          </div>

          {/* Contact Info */}
          <div className="text-center sm:text-left">
            <h4 className="text-xs tracking-[0.3em] uppercase text-[#8b7355] mb-4 sm:mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t.footer.contactTitle}</h4>
            <div className="space-y-3 sm:space-y-4">
              <a href="mailto:info@slaievents.com" className="flex items-center sm:items-start gap-2 sm:gap-3 hover:text-[#8b7355] transition-colors justify-center sm:justify-start">
                <Mail className="w-4 h-4 sm:w-5 sm:h-5 text-[#8b7355] sm:mt-0.5" />
                <span className="text-sm" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>{t.company.email}</span>
              </a>
              <div className="flex items-start gap-2 sm:gap-3 justify-center sm:justify-start">
                <MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-[#8b7355] mt-0.5" />
                <div className="text-sm text-left" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                  <div>{t.company.addressLine1}</div>
                  <div className="pl-3">{t.company.addressLine2}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div className="text-center sm:text-left sm:col-span-2 md:col-span-1">
            <h4 className="text-xs tracking-[0.3em] uppercase text-[#8b7355] mb-4 sm:mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t.footer.hoursTitle}</h4>
            <p className="text-sm text-white/70 mb-3 sm:mb-4" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>{t.company.hours}</p>
            <p className="text-xs text-white/50" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
              {t.footer.availability}
              <br />
              {t.footer.bookAdvance}
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-4 sm:mt-6 pt-4 sm:pt-4 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-0 text-xs text-white/50">
          <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>&copy; 2014 {t.company.name}. {t.footer.copyright}</p>
          <div className="flex gap-2 items-center">
            <Link 
              to={privacyPath} 
              className="text-white/50 hover:text-[#8b7355] transition-colors" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              {t.footer.privacyPolicy}
            </Link>
            <span className="text-white/30">|</span>
            <Link 
              to={language === 'de' ? '/agb' : '/terms'} 
              className="text-white/50 hover:text-[#8b7355] transition-colors" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              {language === 'de' ? 'AGB' : 'Terms'}
            </Link>
            <span className="text-white/30">|</span>
            <Link 
              to={language === 'de' ? '/impressum' : '/imprint'} 
              className="text-white/50 hover:text-[#8b7355] transition-colors" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              {language === 'de' ? 'Impressum' : 'Imprint'}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;